/**
 * Customer Dead Lead List Component
 */
import Paper from '@/components/Paper'
import {
    DataTableCustomized,
    FilterBar,
} from '@/components/ui/data-table-customized'
import type { CustomerDeadLead } from '@/modules/Customer/types'
import { useCustomerDeadLeadList } from '@/modules/Customer/hooks/use-customer-dead-lead-list'

const DeadLead = () => {
    const {
        customers,
        pagination,
        stateComponent,
        params,
        control,
        setFilter,
        searchInputProps,
        columns,
        filterItems,
        handlePageChange,
        handlePageSizeChange,
        handleSortChange,
        t,
    } = useCustomerDeadLeadList()

    return (
        <Paper className="space-y-2 my-2">
            <FilterBar
                control={control}
                setFilter={setFilter}
                items={filterItems}
            />
            {stateComponent || (
                <DataTableCustomized<CustomerDeadLead>
                    columns={columns}
                    rows={customers}
                    rowKey={(row) => row.customer_id}
                    size="small"
                    toolbar={{
                        search: {
                            ...searchInputProps,
                            placeholder: t('search_customers'),
                        },
                        settings: {
                            show: true,
                            storageKey: 'customer-dead-lead-list',
                        },
                    }}
                    stickyHeader={{
                        enabled: true,
                        offsetTopSelector: '#main-header',
                    }}
                    pagination={{
                        page: params.page,
                        pageSize: params.page_size,
                        total: pagination?.total || 0,
                        onPageChange: handlePageChange,
                        onPageSizeChange: handlePageSizeChange,
                    }}
                    sorting={{
                        sortBy: params.sort_by,
                        sortOrder: params.sort_order,
                        onSortChange: handleSortChange,
                    }}
                />
            )}
        </Paper>
    )
}

export default DeadLead
